export default __webpack_public_path__ + "static/media/4.5ef83e8f.jpg";